import { createApiClient } from './httpClient';

const API_BASE = process.env.REACT_APP_REST_BASE_URL || '';
const api = createApiClient({ baseURL: `${API_BASE}/pre-question-bank` });

export const getAllQuestionBanks = async () => {
  const res = await api.get('/');
  return res.data;
};

export const getPlannedTemplates = async () => {
  const res = await api.get('/planned-templates');
  return res.data;
};

export const getQuestionBank = async (templateId) => {
  const res = await api.get(`/${templateId}`);
  return res.data;
};

export const addQuestion = async (templateId, questionPayload) => {
  const res = await api.post(`/${templateId}/questions`, questionPayload);
  return res.data;
};

export const updateQuestion = async (templateId, questionIndex, questionPayload) => {
  const res = await api.put(`/${templateId}/questions/${questionIndex}`, questionPayload);
  return res.data;
};

export const deleteQuestion = async (templateId, questionIndex) => {
  const res = await api.delete(`/${templateId}/questions/${questionIndex}`);
  return res.data;
};

export const reorderQuestions = async (templateId, questionsArray) => {
  const res = await api.put(`/${templateId}/reorder`, questionsArray);
  return res.data;
};

export default {
  getAllQuestionBanks,
  getPlannedTemplates,
  getQuestionBank,
  addQuestion,
  updateQuestion,
  deleteQuestion,
  reorderQuestions,
};
